/**
 * Home screen: quick actions (grid) and bottom links.
 * Single source for blocks that are not yet implemented — show "Скоро" inside.
 */

import { RESERVED_PATHS } from "./navigation.ts";

export type QuickActionIcon =
  | "academicCap"
  | "heart"
  | "hearts"
  | "foldedHands"
  | "receipt"
  | "mapPin"
  | "message"
  | "document"
  | "calendar"
  | "user"
  | "users"
  | "dove"
  | "envelope"
  | "homeHeart"
  | "sparkle"
  | "briefcase"
  | "banknotes"
  | "gift"
  | "heartHands"
  | "crown"
  | "family"
  | "youth";

export interface QuickAction {
  id: string;
  label: string;
  path: string;
  icon: QuickActionIcon;
}

/** Quick actions grid (2×4 or 2×3). Order matters. */
export const QUICK_ACTIONS: QuickAction[] = [
  {
    id: "church",
    label: "О нас",
    path: RESERVED_PATHS.church,
    icon: "users",
  },
  {
    id: "worship",
    label: "Богослужения",
    path: RESERVED_PATHS.worship,
    icon: "dove",
  },
  {
    id: "homeGroups",
    label: "Домашние группы",
    path: RESERVED_PATHS.homeGroups,
    icon: "homeHeart",
  },
  {
    id: "prayers",
    label: "Молитвенные встречи",
    path: RESERVED_PATHS.prayers,
    icon: "foldedHands",
  },
  {
    id: "clubs",
    label: "Бизнес встречи",
    path: RESERVED_PATHS.clubs,
    icon: "briefcase",
  },
  {
    id: "donations",
    label: "Пожертвования",
    path: RESERVED_PATHS.donations,
    icon: "heartHands",
  },
  {
    id: "leadershipSchool",
    label: "Лидерская школа",
    path: RESERVED_PATHS.leadershipSchool,
    icon: "academicCap",
  },
  {
    id: "womensBreakfasts",
    label: "Женские завтраки",
    path: RESERVED_PATHS.womensBreakfasts,
    icon: "crown",
  },
  {
    id: "masterClasses",
    label: "Мастер‑классы",
    path: RESERVED_PATHS.masterClasses,
    icon: "sparkle",
  },
  {
    id: "familyClub",
    label: "Семейный клуб",
    path: RESERVED_PATHS.familyClub,
    icon: "family",
  },
  {
    id: "youth",
    label: "Молодёжка",
    path: RESERVED_PATHS.youth,
    icon: "youth",
  },
  {
    id: "startCourse",
    label: "Курс Старт",
    path: RESERVED_PATHS.startCourse,
    icon: "academicCap",
  },
];

/** Блок снизу на главной «Есть вопросы? Мы рядом»: написать пастору, обратная связь. */
export const BOTTOM_LINKS: {
  label: string;
  path: string;
  icon: "message" | "envelope" | "mapPin" | "receipt";
}[] = [
  { label: "Написать пастору", path: RESERVED_PATHS.pastor, icon: "message" },
  { label: "Обратная связь", path: RESERVED_PATHS.feedback, icon: "envelope" },
];
